import script from "./TermsContentSkatMasters.vue?vue&type=script&setup=true&lang=ts"
export * from "./TermsContentSkatMasters.vue?vue&type=script&setup=true&lang=ts"

import "./TermsContentSkatMasters.vue?vue&type=style&index=0&id=0a69bafe&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a69bafe"]])

export default __exports__